import { render, staticRenderFns } from "./CustomerInfoModal.vue?vue&type=template&id=84f987b0&scoped=true"
import script from "./CustomerInfoModal.vue?vue&type=script&lang=js"
export * from "./CustomerInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f987b0",
  null
  
)

export default component.exports